/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown>, currency: NonNullable<unknown> }} Dailog_Open_Confirmation_ContentInputs */

const en_dailog_open_confirmation_content = /** @type {(inputs: Dailog_Open_Confirmation_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Use ${i?.number} ${i?.currency} to open this cake box?`)
};

const ar_dailog_open_confirmation_content = /** @type {(inputs: Dailog_Open_Confirmation_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`استخدام ${i?.number} ${i?.currency} لفتح صندوق الكعك هذا؟`)
};

const de_dailog_open_confirmation_content = /** @type {(inputs: Dailog_Open_Confirmation_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} ${i?.currency} verwenden, um diese Kuchenbox zu öffnen?`)
};

const es_dailog_open_confirmation_content = /** @type {(inputs: Dailog_Open_Confirmation_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Usar ${i?.number} ${i?.currency} para abrir esta caja de pasteles?`)
};

const fr_dailog_open_confirmation_content = /** @type {(inputs: Dailog_Open_Confirmation_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Utiliser ${i?.number} ${i?.currency} pour ouvrir cette boîte à gâteaux ?`)
};

const it_dailog_open_confirmation_content = /** @type {(inputs: Dailog_Open_Confirmation_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usare ${i?.number} ${i?.currency} per aprire questa scatola di torte?`)
};

const ja_dailog_open_confirmation_content = /** @type {(inputs: Dailog_Open_Confirmation_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} ${i?.currency}を使用してこのケーキボックスを開けますか？`)
};

const ko_dailog_open_confirmation_content = /** @type {(inputs: Dailog_Open_Confirmation_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} ${i?.currency}를 사용하여 이 케이크 상자를 개봉하시겠습니까?`)
};

const pt_br_dailog_open_confirmation_content = /** @type {(inputs: Dailog_Open_Confirmation_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usar ${i?.number} ${i?.currency} para abrir esta caixa de bolo?`)
};

const ru_dailog_open_confirmation_content = /** @type {(inputs: Dailog_Open_Confirmation_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Использовать ${i?.number} ${i?.currency}, чтобы открыть эту коробку с тортом?`)
};

const th_dailog_open_confirmation_content = /** @type {(inputs: Dailog_Open_Confirmation_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ใช้ ${i?.number} ${i?.currency} เพื่อเปิดกล่องเค้กนี้หรือไม่?`)
};

const tr_dailog_open_confirmation_content = /** @type {(inputs: Dailog_Open_Confirmation_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bu pasta kutusunu açmak için ${i?.number} ${i?.currency} kullanılsın mı?`)
};

const zh_cn_dailog_open_confirmation_content = /** @type {(inputs: Dailog_Open_Confirmation_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`使用 ${i?.number} ${i?.currency} 打开这个蛋糕礼盒吗？`)
};

const zh_tw_dailog_open_confirmation_content = /** @type {(inputs: Dailog_Open_Confirmation_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`用 ${i?.number} ${i?.currency}打開一個蛋糕禮盒嗎？`)
};

/**
* | output |
* | --- |
* | "Use {number} {currency} to open this cake box?" |
*
* @param {Dailog_Open_Confirmation_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dailog_open_confirmation_content = /** @type {((inputs: Dailog_Open_Confirmation_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dailog_Open_Confirmation_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dailog_open_confirmation_content(inputs)
	if (locale === "ar") return ar_dailog_open_confirmation_content(inputs)
	if (locale === "de") return de_dailog_open_confirmation_content(inputs)
	if (locale === "es") return es_dailog_open_confirmation_content(inputs)
	if (locale === "fr") return fr_dailog_open_confirmation_content(inputs)
	if (locale === "it") return it_dailog_open_confirmation_content(inputs)
	if (locale === "ja") return ja_dailog_open_confirmation_content(inputs)
	if (locale === "ko") return ko_dailog_open_confirmation_content(inputs)
	if (locale === "pt_br") return pt_br_dailog_open_confirmation_content(inputs)
	if (locale === "ru") return ru_dailog_open_confirmation_content(inputs)
	if (locale === "th") return th_dailog_open_confirmation_content(inputs)
	if (locale === "tr") return tr_dailog_open_confirmation_content(inputs)
	if (locale === "zh_cn") return zh_cn_dailog_open_confirmation_content(inputs)
	return zh_tw_dailog_open_confirmation_content(inputs)
});